import React, { Component } from "react";
import Transporte from "../Resources/transporte.svg";
import Card from "../Card/Card";
import "./AccesibilidadEnTransportes.css";
import fav from "../Resources/logo-salidas.png";
import { Link } from "react-router-dom";

export class AccesibilidadEnTransportes extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <main class="container-fluid text-center mb-5">
                <div class="row d-flex align-items-center justify-content-center">
                    <Link to="/">
                        <img src={fav} width={200} alt=""></img>
                    </Link>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12">
                        <h3 class="title">Accesibilidad En Transportes</h3>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12">
                        <div class="container-transporte d-flex align-items-center justify-content-center bg-container-transporte p-5">
                            <Card
                                svg={Transporte}
                                title={
                                    "¿Por qué es importante la accesibilidad cognitiva en el trasporte público?"
                                }
                                width={"100"}
                                height={"100"}
                                maxWidth="1000"
                                animation={false}
                                pagination={false}>
                                <div class="card-body-transporte">
                                    <p>
                                        La{" "}
                                        <strong>accesibilidad cognitiva</strong>{" "}
                                        tiene como objetivo crear y/o adaptar
                                        espacios para que una persona pueda
                                        comprender, procesar y utilizar la
                                        información en su ámbito de{" "}
                                        <strong>forma autónoma</strong>. Para
                                        ello, se nutre de{" "}
                                        <strong>apoyos visuales</strong> como
                                        pictogramas, señalización clara y
                                        secuencial, colores contrastantes e
                                        información gráfica, que facilitan la
                                        interpretación y el uso del entorno. La
                                        accesibilidad cognitiva es fundamental
                                        para personas neurodivergentes y
                                        beneficia también a adultos mayores,
                                        turistas, niños pequeños y cualquier
                                        usuario que necesite una comunicación
                                        más clara. Su principal propósito es{" "}
                                        <strong>
                                            eliminar barreras de comprensión
                                        </strong>
                                        , garantizando que la información sea
                                        sencilla y visualmente accesible.
                                    </p>
                                    <p>
                                        La accesibilidad cognitiva en el
                                        transporte público es clave para{" "}
                                        <strong>
                                            garantizar desplazamientos seguros,
                                            autónomos, eficientes
                                        </strong>
                                        , moverse con mayor confianza,
                                        asegurando la inclusión social y el
                                        acceso a más oportunidades. Además,
                                        mejora la organización del sistema de
                                        transporte, reduciendo errores, estrés y
                                        tiempo de espera para todos los
                                        pasajeros.
                                    </p>
                                    <p>
                                        A continuación, se comparten una serie
                                        de materiales de accesibilidad cognitiva
                                        diseñados específicamente para trenes y
                                        colectivos, con el objetivo de facilitar
                                        la comprensión y el uso de estos medios
                                        de transporte.
                                    </p>
                                    <p>
                                        {" "}
                                        En <strong>Salidas Inclusivas</strong>,
                                        buscamos que estos materiales lleguen a
                                        la mayor cantidad de personas que los
                                        necesiten o les sean útiles, promoviendo
                                        una movilidad más accesible para todos.
                                    </p>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <Link
                                            to="/lineascolectivos"
                                            class="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Líneas de colectivos
                                        </Link>
                                    </div>

                                    <div className="d-flex flex-row flex-wrap justify-content-center">
                                        <Link
                                            to="/trenes"
                                            class="btn btn-primary col-md-8 col-6 mx-1"
                                            style={{ minWidth: "260px" }}>
                                            Trenes
                                        </Link>
                                    </div>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </main>
        );
    }
}
